"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var header_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/request_list/header"));
var request_item_list_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/request_list/request_item_list"));
var RequestList = function (props) { return (react_1.default.createElement(react_1.Fragment, null,
    react_1.default.createElement(header_1.default, { isWindowOpened: props.isWindowOpened, onClickHeader: props.onClickHeader, onClickCloseButton: props.onClickCloseButton, onClickMessageListButton: props.onClickMessageListButton }),
    props.requestItems.length === 0
        ? react_1.default.createElement("div", { className: "unreadRequestWindow-Body" },
            react_1.default.createElement("div", { className: "unreadRequestWindow-Body_Label" }, "\u3059\u3079\u3066\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8FD4\u4FE1\u3057\u307E\u3057\u305F"))
        : react_1.default.createElement(request_item_list_1.default, { requestItems: props.requestItems, onClickRequestItemBox: props.onClickRequestItemBox }))); };
exports.default = RequestList;
